import './HvacFormSetupOption.scss';
import { EnergyEfficiencyClass } from '@belimo-retrofit-portal/logic';
import clsx from 'clsx';
import React from 'react';
import { EnergyEfficiencyLabel } from 'src/modules/common/components/EnergyEfficiencyLabel';
import { LABELS } from 'src/modules/common/constants/energyEfficiencyLabels';
import { BodyMedium02 } from 'src/modules/common/typography/BodyMedium02';
import { BodySmall02 } from 'src/modules/common/typography/BodySmall02';

type Props = {
  readonly label: React.ReactNode;
  readonly comment: React.ReactNode;
  readonly renderComment: boolean;
  readonly renderEfficiencyLabel?: boolean;
  readonly energyEfficiencyClass?: EnergyEfficiencyClass;
};

export const HvacFormSetupOption = ({
  label,
  comment,
  renderComment,
  renderEfficiencyLabel,
  energyEfficiencyClass,
}: Props): React.ReactElement => (
  <div className={clsx(
    'bp-hvac-form-setup-option',
    { 'bp-hvac-form-setup-option--with-comment': renderComment && comment },
  )}
  >
    {renderEfficiencyLabel && (
      <div className="bp-hvac-form-setup-option__label">
        <EnergyEfficiencyLabel fixed={true} value={energyEfficiencyClass || null} size="sm">
          {energyEfficiencyClass ? LABELS[energyEfficiencyClass] : '\u2013' }
        </EnergyEfficiencyLabel>
      </div>
    )}

    <div className="bp-hvac-form-setup-option__content">
      <BodyMedium02>
        {label}
      </BodyMedium02>

      {(renderComment && comment) && (
        <BodySmall02>
          {comment}
        </BodySmall02>
      )}
    </div>
  </div>
);
